export const color ={
    grey:[
        "",
        "#FAFAFA",
        "#E9E9E9",
        "#D4D4D4",
        "#888888",
        "#666666",
        "#4444",
        "#222222",
    ],
    main:[
        "",
        "#272727",
        "#007DFE",
        "#FFE214"
    ],
    white:[
        '#FFFFFF'
    ]
};

export const fontsize =[
    "",
    "12px", //1
    "16px", //2
    "20px", //3
    "24px", //4
    "32px", //5
    "36px", //6
];

export const fontWeight =[
    "500", //0
    "600", //1
    "700", //2
    "800", //3
    "400" //extrabold
];